import { Grid, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
// import CustomButton from '../../shared/CustomButton';
import QuizAccordian from './QuizAccordian';
// import { ReactComponent as Envelope } from '../../../assets/envelope.svg';

const useStyles = makeStyles({
  topBarContainer: {
    width: 390,
    height: 48,
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    paddingTop: 8,
    paddingRight: 16,
    paddingBottom: 8,
    paddingLeft: 16,
    background: '#FEFEFE',
    borderBottom: '1px solid #E4E7EC',
    display: 'flex',
    alignItems: 'center',
  },
  topBarText: {
    fontFamily: 'Lato !important',
    fontWeight: '600 !important',
    fontSize: '16px !important',
    lineHeight: '140% !important',
    letterSpacing: '0 !important',
    color: '#10182B !important',
  },
});

const RightSideQuiz = () => {
  const classes = useStyles();
  const overview = useSelector((state) => state?.getQuizSeries?.quizSeriesOverview);
  const details = useSelector((state) => state?.getQuiz?.quizDetails);

  let index = 0;
  if (overview && details) index = overview?.quizzes?.findIndex((item) => item?.id === details?.id);
  if (!overview?.quizzes?.length) return null;

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <Grid container direction="row" justifyContent="space-between" className={classes.topBarContainer}>
          <Grid item>
            <Typography className={classes.topBarText}>{`Quiz ${index + 1 || 1} Questions (${
              details?.questions?.length || 0
            })`}</Typography>
          </Grid>
          <Grid item>
            {/* <CustomButton icon={<Envelope />} label="Email Question Analysis" type="secondary" size="small" /> */}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <QuizAccordian />
      </Grid>
    </Grid>
  );
};
export default RightSideQuiz;
